export default values => {
  const errors = {};

  if (!values.name || !values.description || !values.inspection_type) {
    errors.details_page_errors = 'Template details have not been filled out';
  }

  return errors;
};
